<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Get Logs</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn @click="init">Reload</v-btn>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col cols="12" sm="4" md="4" lg="4">
          <v-combobox color="#0F2027" clearable :loading="load" v-model="username" :items="all_users"
            label="Select Username" hint="Search by username (optional)" persistent-hint
            item-text="username"></v-combobox>
        </v-col>
        <v-col cols="12" sm="4" md="4" lg="4">
          <v-text-field v-model.trim="link" label="Enter Url/Link" hint="Search by page-url (optional)"
            persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="6" md="4" lg="4">
          <v-icon color="error">*</v-icon>
          From Date (inclusive) ::
          <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="fromdate" />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <v-icon color="error" class="ml-3">*</v-icon>
          To Date (exclusive)::
          <input class="mt-7 ml-2 pt-0" id="datePickerId" type="date" v-model="todate" />
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="2" md="2" lg="2"></v-col>
        <v-col cols="12" sm="4" md="4" lg="4">
          <v-btn @click="getData()" :disabled="fromdate == false || todate == false" :loading="loader"
            class="button mt-7 pt-0">Proceed</v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        Note: It may take several minutes depending upon data fetched or date
        range selection
      </v-row>
    </v-card>
    <!-- Logs:: {{ log_list }} -->
    <template>
      <div>
        <v-card class="box" v-if="log_list.length > 0">
          <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'LogsReport')"
            :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
          <v-card-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
              hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-btn @click="reverse">Reverse</v-btn>
          </v-card-title>
          <v-data-table :headers="headers" :items="bookList1" class="elevation-1 mytable" :search="search"
            @current-items="getFiltered">
            <!-- filters for data table -->

            <template v-slot:top class="pb-5">
              <v-row>
                <v-col cols="12" sm="1" md="1"></v-col>
                <tr>
                  <div>
                    <th>
                      <v-row>
                        <span v-for="header in headers" :key="header.text">
                          <span v-if="filters.hasOwnProperty(header.value)">
                            <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                              color="#0F2027" :label="header.text" multiple clearable
                              :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                          </span>
                        </span>
                      </v-row>
                    </th>
                  </div>
                </tr>
              </v-row>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    headers: [
      { text: "UID", value: "uid", width: "220px" },
      { text: "By-passed", value: "bypassed_by", width: "180px" },
      { text: "Action", value: "link", width: "280px" },
      { text: "Request From", value: "request_from_url", width: "220px" },
      { text: "Date", value: "date", width: "170px" },
      { text: "Domain", value: "origin_domain", width: "180px" },
      { text: "IP-1", value: "ip", width: "160px" },
      { text: "IP-2", value: "ip_2", width: "160px" },
      { text: "Other", value: "cum_data", width: "420px" },
    ],
    search: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    academic_year_list: null,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    loader: false,
    load: true,
    todate: false,
    fromdate: false,
    all_users: [],
    link: null,
    username: null,
    log_list: [],
    filterArr: [],
    filters: {
      uid: [],
      bypassed_by: [],
      link: [],
      request_from_url: [],
    },
  }),

  methods: {
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>UID</th>
      <th>By-passed</th>
      <th>Action</th>
      <th>Request form</th>
      <th>Date</th>
      <th>Domain</th>
      <th>Other</th>
    </tr>`;

  this.bookList1.forEach((s, index) => {
    tab_text += `
      <tr>
        <td>${s.uid}</td>
        <td>${s.bypassed_by}</td>
        <td>${s.link}</td>
        <td>${s.request_from_url}</td>
        <td>${s.date}</td>
        <td>${s.origin_domain}</td>
        <td>${s.cum_data}</td>
        
      </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
    getFiltered(e) {
      this.filterArr = e;
    },
    columnValueList(val) {
      console.log("in colfunc", val);
      return this.log_list.map((d) => d[val]);
    },
    reverse() {
      this.log_list.reverse();
    },
    getData() {
      if (this.fromdate == false) {
        alert("Please select From Date!!!");
        return;
      }
      if (this.todate == false) {
        alert("Please select To Date!!!");
        return;
      }
      var formData;
      if (this.username != null && this.link != null) {
        formData = {
          fromdate: this.fromdate,
          todate: this.todate,
          username: this.username.username,
          link: this.link,
        };
      } else if (this.username != null) {
        formData = {
          fromdate: this.fromdate,
          todate: this.todate,
          username: this.username.username,
        };
      } else if (this.link != null) {
        formData = {
          fromdate: this.fromdate,
          todate: this.todate,
          link: this.link,
        };
      } else {
        formData = {
          fromdate: this.fromdate,
          todate: this.todate,
        };
      }
      this.loader = true;
      axios
        .post("/admin/getLogs", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", res.data.snackbar);
            this.log_list = res.data.log_list;
          } else {
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.showSnackbar("red", res.data.snackbar);
          }
          this.loader = false;
        })
        .catch((error) => {
          this.showSnackbar("red", "Something went wrong....");
          this.loader = false;
        })
        .finally(() => {
          //close loader
          this.loader = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    init() {
      this.log_list = [];
      this.link = null;
      this.load = true;
      axios
        .post("/Admin/getAllUser")
        .then((res) => {
          this.all_users = res.data.all_users;
          this.load = false;
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    bookList1() {
      return this.log_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
};
</script>
<style scoped>
input[type="date"] {
  width: 50%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}
.v-data-table td {
  white-space: nowrap;
}

.v-data-table td:last-child {
  white-space: normal !important;
  word-break: break-word;
  min-width: 420px;
  max-width: 420px;
}
</style>
